type Props = {
  caption?: string;
  className?: string;
};

export default function ImageCaption({ caption, className }: Props) {
  if (!caption) return null;

  return (
    <span
      className={`absolute bottom-3 left-3 z-10 text-sm font-semibold text-white text-shadow-outline ${className ?? ''}`}
    >
      {caption}
    </span>
  );
}
